
import Button from "@/components/base/Button"

import { Search } from "@/models/search"
import { location } from "@/assets/icons/js"

export default {
    name: "SearchNoResults",
    components: {
        Button,
    },
    props: {
        /**
         * is this the initial search (without any filters / query / category selected)
         */
        search: {
            type: Search,
            required: true,
        },
        /**
         * search location/channel name displayed on the page (e.g. Passau)
         */
        searchAreaName: {
            type: String,
            default: "",
        },
    },
    icons: {
        location,
    },
    computed: {
        initialSearch() {
            return this.search.numberOfActiveFilters === 0
        },
    },
    methods: {
        onClickChange() {
            if (this.initialSearch) {
                this.$emit("click:location")
            } else {
                this.resetSearch()
            }
        },
        resetSearch() {
            this.search.resetQuery()
            this.$router.push(this.search.getRoute())
            this.search.execute()
        },
        onResetTraineeship() {
            this.search.setHasTraineeship(false)
            this.$router.push(this.search.getRoute())
            this.search.execute()
        },
    },
}
